import { NavLink, ThemeIcon } from '@mantine/core';
import { IconShieldCheck } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums/routes';

interface EpiLinkProps {
  navigate(route: string): void;
}

export function EpiLink({ navigate }: EpiLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: '#373A40',
        },
      }}
      label="EPIs"
      fw="bold"
      icon={
        <ThemeIcon color="green" variant="light">
          <IconShieldCheck size={16} />
        </ThemeIcon>
      }
    >
      <NavLink
        label="Gestão de EPIs"
        onClick={() => navigate(AppRoutePaths.EPIS)}
      />
      <NavLink
        label="Catálogo de EPIs"
        onClick={() => navigate(AppRoutePaths.EPI_CATALOG)}
      />
      <NavLink
        label="Matriz de EPIs"
        onClick={() => navigate(AppRoutePaths.EPI_MATRIX)}
      />
      <NavLink
        label="Histórico de Entregas"
        onClick={() => navigate(AppRoutePaths.EPI_DELIVERIES)}
      />
      <NavLink
        label="Rondas de EPI"
        onClick={() => navigate(AppRoutePaths.EPI_ROUNDS)}
      />
      <NavLink
        label="Relatórios de EPI"
        onClick={() => navigate(AppRoutePaths.EPI_REPORTS)}
      />
    </NavLink>
  );
}
